/**
 * Parses a page number from a string parameter with validation.
 * Returns 1 as default for invalid or missing values.
 * @param pageParam - The page parameter string to parse
 * @returns A valid page number (integer > 0) or 1 as default
 */
export function parsePageNumber(pageParam: string | null): number {
  if (!pageParam) {
    return 1
  }
  const parsedPage = Number(pageParam)
  const isValidPageParam = Number.isInteger(parsedPage) && parsedPage > 0
  return isValidPageParam ? parsedPage : 1
}

/**
 * Encodes a path part, preserving forward slashes (e.g. branch names like "feature/foo").
 */
function encodePart(part: string): string {
  return part.split('/').map(encodeURIComponent).join('/')
}

/**
 * Generates the encoded URL path to an automation's .md file in the repository blob view.
 * @param owner - Repository owner
 * @param repo - Repository name
 * @param defaultBranch - Default branch of the repository
 * @param automationName - Name of the automation (without .md extension)
 * @returns Encoded URL path (e.g., "/owner/repo/blob/main/.github/agents/my%20automation.md")
 */
export function automationFilePath(owner: string, repo: string, defaultBranch: string, automationName: string): string {
  return `/${owner}/${repo}/blob/${encodePart(defaultBranch)}/.github/agents/${encodeURIComponent(automationName)}.md`
}
